export {};

const arrow = 'arrow-v3';
const sliderSelector = '.js-single-carousel';
const arrowPrev = `<button type="button" class="strategy-slider__arrow strategy-slider__arrow--prev"><svg class="svg-symbol svg-symbol--${arrow} svg-symbol--${arrow}-left"><use xlink:href="#svg-symbol--${arrow}-left"/></svg></button>`;
const arrowNext = `<button type="button" class="strategy-slider__arrow strategy-slider__arrow--next"><svg class="svg-symbol svg-symbol--${arrow} svg-symbol--${arrow}-right"><use xlink:href="#svg-symbol--${arrow}-right"/></svg></button>`;

$(singleCarouselInit);

NLMK.singleCarouselInit = singleCarouselInit;

function singleCarouselInit() {
    $(sliderSelector).each(function() {
        const $self = $(this);
        const infinite = $self.data('infinite');

        $self.slick({
            dots: false,
            arrows: true,
            infinite: typeof infinite !== 'undefined' && !!infinite,
            slidesToShow: 1,
            appendArrows: '.single-carousel__nav',
            prevArrow: arrowPrev,
            nextArrow: arrowNext,
        });
    });
}



// WEBPACK FOOTER //
// ./js/main/module/sliders/single-carousel.js